"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconUnfocus', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M7.02882095,14.4478088 L3.73529779,17.6809342 C3.34375289,18.0652988 2.71562919,18.0623926 2.32765781,17.6744212 L2.3211445,17.6679079 C1.93421741,17.2809808 1.93421741,16.653648 2.3211445,16.2667209 C2.32330555,16.2645599 2.32547658,16.2624088 2.32765753,16.2602679 L5.64367547,13.0050602 L3.02882095,13.0050602 C2.4765362,13.0050602 2.02882095,12.557345 2.02882095,12.0050602 C2.02882095,11.4527755 2.4765362,11.0050602 3.02882095,11.0050602 L8.02882095,11.0050602 C8.5811057,11.0050602 9.02882095,11.4527755 9.02882095,12.0050602 L9.02882095,17.0050602 C9.02882095,17.557345 8.5811057,18.0050602 8.02882095,18.0050602 C7.4765362,18.0050602 7.02882095,17.557345 7.02882095,17.0050602 L7.02882095,14.4478088 Z M13,5.55725141 L16.2935232,2.32412602 C16.6850681,1.9397614 17.3131918,1.94266767 17.7011631,2.33063905 L17.7076764,2.33715235 C18.0946035,2.72407945 18.0946035,3.35141221 17.7076764,3.7383393 C17.7055154,3.74050035 17.7033444,3.74265138 17.7011634,3.74479234 L14.3851455,7 L17,7 C17.5522847,7 18,7.44771525 18,8 C18,8.55228475 17.5522847,9 17,9 L12,9 C11.4477153,9 11,8.55228475 11,8 L11,3 C11,2.44771525 11.4477153,2 12,2 C12.5522847,2 13,2.44771525 13,3 L13,5.55725141 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;